import { render, staticRenderFns } from "./gc-date.vue?vue&type=template&id=4eaabe1e"
import script from "./gc-date.vue?vue&type=script&lang=js"
export * from "./gc-date.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports